// Persistance du choix de thème.
//
// Le CSS du sombre était entièrement câblé et testé — `main.tsx` posait les
// sélecteurs `[data-theme]`, `app.css` les gérait, `theme.test.ts` les
// vérifiait — mais AUCUN code ne posait jamais l'attribut. Le mode sombre
// existait et était inatteignable. C'est ce fichier qui manquait.

import { applyTheme, type ThemeChoice } from '@ai-job-fit/ui'

const KEY = 'console.theme'

const isChoice = (v: unknown): v is ThemeChoice => v === 'auto' || v === 'light' || v === 'dark'

export function readTheme(): ThemeChoice {
  try {
    const stored = localStorage.getItem(KEY)
    return isChoice(stored) ? stored : 'auto'
  } catch {
    // Navigateur en mode restreint : on suit le système, sans casser l'app.
    return 'auto'
  }
}

export function writeTheme(choice: ThemeChoice): void {
  applyTheme(document.documentElement, choice)
  try {
    localStorage.setItem(KEY, choice)
  } catch {
    // Le thème s'applique quand même, il ne survivra simplement pas au reload.
  }
}

/** Appelé avant le premier rendu, pour éviter le clignotement de thème. */
export function applyStoredTheme(): void {
  applyTheme(document.documentElement, readTheme())
}
